<div 
  class="container"
  [ngClass]="{ 
    'info': priority === 'info', 
    'warning': priority === 'warning', 
    'error': priority === 'error'
    }"
>
  <h4 class="iris-body-bold">{{ title }}</h4>
  <p class="iris-body">{{ body }}</p>
</div>